import { __assign, __rest } from "tslib";
import * as React from 'react';
/**
 * Represents a review value.
 */
export var ReviewValue = function (_a) {
    var label = _a.label, children = _a.children, props = __rest(_a, ["label", "children"]);
    return (React.createElement("div", __assign({}, props, { className: "review-value" }),
        React.createElement("label", null, label),
        React.createElement("output", null, children)));
};
//# sourceMappingURL=ReviewValue.js.map